/**
 * Administracja → Słowniki (`dict.*`), scalane przez `extra.ts`. `dictEn` jest typowany względem `dictPl`.
 */
export const dictPl = {
  title: 'Słowniki',
  subtitle: 'Listy wyboru używane w formularzach — zmiany widzą od razu wszyscy użytkownicy organizacji.',
  chips: { active: 'Aktywne', inactive: 'Wyłączone' },
  suppliers: {
    title: 'Dostawcy konkurencji',
    hint: 'Lista „Obecny dostawca” w raporcie dziennym handlowca. Opcja „Inny” z polem tekstowym jest zawsze dostępna i nie jest wpisem słownika. Wyłączony dostawca znika z listy wyboru, ale zostaje w zapisanych raportach.',
    addLabel: 'Nowy dostawca',
    addPlaceholder: 'Nazwa dostawcy',
    add: 'Dodaj',
    empty: 'Słownik jest pusty — dodaj pierwszego dostawcę.',
    loadError: 'Nie udało się wczytać słownika.',
    inactiveBadge: 'Wyłączony',
    moveUp: 'Przesuń wyżej',
    moveDown: 'Przesuń niżej',
    edit: 'Zmień nazwę',
    save: 'Zapisz',
    cancel: 'Anuluj',
    enable: 'Włącz',
    disable: 'Wyłącz',
    added: 'Dodano dostawcę „{name}”.',
    saved: 'Zapisano zmiany.',
    nameRequired: 'Podaj nazwę.',
    nameTooLong: 'Nazwa może mieć najwyżej {max} znaków.',
    errors: {
      NAME_EXISTS: 'Dostawca o tej nazwie już jest w słowniku.',
      NOT_FOUND: 'Nie znaleziono dostawcy — odśwież listę.',
      FORBIDDEN: 'Brak uprawnień do zmiany słownika.',
      generic: 'Nie udało się zapisać zmian.',
    },
  },
};

export const dictEn: typeof dictPl = {
  title: 'Dictionaries',
  subtitle: 'Choice lists used in forms — changes are visible to everyone in the organization right away.',
  chips: { active: 'Active', inactive: 'Disabled' },
  suppliers: {
    title: 'Competitor suppliers',
    hint: 'The "Current supplier" list in the sales rep daily report. The "Other" option with a text field is always available and is not a dictionary entry. A disabled supplier disappears from the choice list but stays in saved reports.',
    addLabel: 'New supplier',
    addPlaceholder: 'Supplier name',
    add: 'Add',
    empty: 'The dictionary is empty — add the first supplier.',
    loadError: 'Could not load the dictionary.',
    inactiveBadge: 'Disabled',
    moveUp: 'Move up',
    moveDown: 'Move down',
    edit: 'Rename',
    save: 'Save',
    cancel: 'Cancel',
    enable: 'Enable',
    disable: 'Disable',
    added: 'Supplier "{name}" added.',
    saved: 'Changes saved.',
    nameRequired: 'Enter a name.',
    nameTooLong: 'The name can have at most {max} characters.',
    errors: {
      NAME_EXISTS: 'A supplier with this name is already in the dictionary.',
      NOT_FOUND: 'Supplier not found — refresh the list.',
      FORBIDDEN: 'You are not allowed to change the dictionary.',
      generic: 'Could not save the changes.',
    },
  },
};
